import(/* webpackMode: "eager" */ "/home/runner/work/franckdemoute.fr/franckdemoute.fr/app/page.tsx");
